import React, { Component } from 'react'
import { connect } from 'react-redux'
import AccessResult from './AccessResult'
import TicketResult from './TicketResult'
import http from 'API/http'
import axios from 'axios'
const CancelToken = axios.CancelToken


class SmallSearch extends Component {
  constructor (props) {
    super(props)
    this.state = {
      limit: 10,
      menu: false,
      index: props.search.index,
      icon: 'fa-globe',
      location: 1,
      fieldFocused: false,
      loading: false
    }
    this.timer = null
    this.cancelToken = CancelToken.source()
  }
  componentDidMount () {
    var pos
    this.clearSearch()
    document.addEventListener('keydown', (event) => {
      if (this.props.search.results && this.props.search.results && this.props.search.results.length) {
        switch (event.keyCode) {
          case 40:
            pos = this.state.location + 1
            if (pos > this.props.search.results.length) {
              pos = 1
            }
            return (this.setState({location: pos}))
          case 38:
            pos = this.state.location - 1
            if (pos < 1) {
              pos = this.props.search.results.length
            }
            return (this.setState({location: pos}))
          case 13:
            window.location = (window.location.hash.indexOf('ticket') === -1 ? ('#/access/' + this.props.search.results[this.state.location - 1].accessId) : ('#/ticket/' + this.props.search.results[this.state.location - 1].ticketRef))
            return (this.clearSearch())
          case 27:
            return (this.clearSearch())
        }
      }

      if (event.keyCode === 13 && !this.props.search.results && this.state.fieldFocused) {
        this.dispatchQuery(this.searchField.value, (window.location.hash.indexOf('ticket') === -1))
      } else if (!this.searchField.value.length) {
        this.clearSearch()
      }
    }, false)
  }
  setIndex (index, icon) {
    this.setState({menu: false, index: index, icon: icon})
    return false
  }
  handleChange (event, access) {
    console.log("new char");
    this.setState({loading: true})
    var query = event.target.value
    clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.dispatchQuery(query, access)
    }, 350)
  }
  async dispatchQuery (query, access) {
    this.cancelToken.cancel()
    let cancelToken = CancelToken.source()
    this.cancelToken = cancelToken
    var endpoint = (access ? '2.3/accesses/search/' : '2.3/tickets/search/')
    var [err, res] = await http.get(endpoint + query, {limit: this.state.limit}, null, { cancelToken: cancelToken.token })
    if (err) return this.setState({loading: false})
    this.props.dispatch({
      type: 'SET_SEARCH',
      payload: {
        query: query,
        results: res.data,
        index: access
      }
    })
    this.setState({loading: false})
  }
  clearSearch () {
    this.props.dispatch({
      type: 'SET_SEARCH',
      payload: {
        query: '',
        total: 0,
        results: false
      }
    })
  }
  render () {
    console.log(this.props.search);
    var access
    access = (window.location.hash.indexOf('ticket') === -1)
    var i = 0
    return (
      <div className='navbar-form navbar-right navbar-search search form-group'>
        <div className='input-group'>
          <span className='input-group-addon access-search-field-indicator pull-left'>
            {access ? <i className='fa fa-home' /> : <i className='fa fa-commenting-o' />}
          </span>
          <input
            ref={el => (this.searchField = el)}
            type='text'
            defaultValue={this.props.search.query}
            onChange={(e) => {
              this.handleChange(e, access)
            }}
            onFocus={e => this.setState({fieldFocused: true})}
            onBlur={e => this.setState({fieldFocused: false})}
            className='form-control navbar-search-field'
            placeholder={access ? 'Search Accesses' : 'Search Tickets'} />
        </div>
        {this.state.loading &&
          <div className='list-group flow-search-results small-search-results'>
            <div className='no-data-in-table-wrapper'>
              <div className='no-data-text-wrapper'>
                <i className='fa fa-circle-o-notch fa-spin' />
                <h3 className='text-center no-data-text'>Loading</h3>
              </div>
            </div>
          </div>
        }
        {!this.state.loading && !this.props.search.results && this.searchField && this.state.fieldFocused && this.searchField.value.length !== 0 &&
          <div className='list-group flow-search-results small-search-results'>
            <div className='no-data-in-table-wrapper'>
              <div className='no-data-text-wrapper'>
                <i className='fa fa-exclamation' />
                <h3 className='text-center no-data-text'>No results</h3>
              </div>
            </div>
          </div>
        }
        <div className={'list-group flow-search-results small-search-results ' + ((this.props.search.results && this.props.search.results.length) && !this.state.loading && !(window.location.hash.indexOf('search') > -1) ? '' : 'hidden')}>
          {this.props.search.results && this.props.search.results.map((result) => {
            i += 1
            return access ? <AccessResult key={i} clearSearch={e => this.clearSearch()} result={result} active={(i === this.state.location)} /> : <TicketResult clearSearch={e => this.clearSearch()} result={result} key={i} active={(i === this.state.location)} />
          })}
          <a href='/#/search' className='list-group-item text-right active list-group-item-results'>
            <h5 className='list-group-item-heading'>Show all results</h5>
          </a>
          <div className='small-search-overlay' onClick={() => this.clearSearch()} />
        </div>
      </div>
    )
  }
}
// eslint-disable-next-line
SmallSearch = connect(state => state.siteReducer)(SmallSearch)
export default SmallSearch



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/components/core/search/SmallSearch.js